"use strict";
/**
 * Off-Sequence Notes formatter.
 *
 * Builds the same string that the legacy Angular app sends to Salesforce via
 * esil-crm.  The format is dictated by SSC (Student Success Center) and looks
 * like:
 *
 *   2019 Fall A, 7/31/19 / 9/30/19, C&T-743
 *   2020 Spring, 12/31/19 / 4/30/20, C&T-750 C&T-500
 *
 * Each line represents one term in the plan.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFinalActiveTermSfName = exports.buildOffSequenceNotes = void 0;
/**
 * Format a Date as M/d/yy (e.g. 7/31/19) — matches Angular's DatePipe('en-US', 'M/d/yy').
 * Uses UTC accessors because API dates represent calendar dates, not local-TZ instants.
 */
const formatShortDate = (date) => {
    const d = new Date(date);
    const month = d.getUTCMonth() + 1;
    const day = d.getUTCDate();
    const year = String(d.getUTCFullYear()).slice(-2);
    return `${month}/${day}/${year}`;
};
/**
 * Build the off-sequence notes string from plan terms, resolving full term/course
 * data from the loaded reference lists.
 */
const buildOffSequenceNotes = ({ planTerms, availableTerms, availableCourses, }) => {
    const termsMap = new Map(availableTerms.map((t) => [t.id, t]));
    const coursesMap = new Map(availableCourses.map((c) => [c.id, c]));
    let notes = '';
    for (const planTerm of planTerms) {
        const term = termsMap.get(planTerm.term.id);
        if (!term)
            continue;
        const courseCodes = planTerm.courses
            .map((c) => {
            var _a;
            const course = coursesMap.get(c.course.id);
            return (_a = course === null || course === void 0 ? void 0 : course.code) !== null && _a !== void 0 ? _a : '';
        })
            .filter(Boolean)
            .join(' ');
        const startDate = formatShortDate(term.startDate);
        const endDate = formatShortDate(term.endDate);
        notes += `\n${term.name}, ${startDate} / ${endDate}, ${courseCodes} `;
    }
    return notes;
};
exports.buildOffSequenceNotes = buildOffSequenceNotes;
/**
 * Find the final-active term for a plan and return its Salesforce term name.
 */
const getFinalActiveTermSfName = (finalActiveTermId, availableTerms) => {
    var _a;
    if (!finalActiveTermId)
        return '';
    const term = availableTerms.find((t) => t.id === finalActiveTermId);
    return (_a = term === null || term === void 0 ? void 0 : term.sfTermName) !== null && _a !== void 0 ? _a : '';
};
exports.getFinalActiveTermSfName = getFinalActiveTermSfName;
